// src/utils/csvExport.js

// ✅ Escape CSV safe
// const escapeCSV = (value) => {
//   if (value === null || value === undefined) return "";

//   let str = String(value);

//   // replace line breaks
//   str = str.replace(/\r?\n|\r/g, " ");

//   // if contains comma / quote / newline wrap with quotes
//   if (str.includes(",") || str.includes('"')) {
//     str = `"${str.replace(/"/g, '""')}"`;
//   }

//   return str;
// };

const escapeCSV = (value) => {
  if (value === null || value === undefined) return '';

  let str = String(value);

  // ⭐ IMPORTANT FIX (THIS LINE SOLVES YOUR PROBLEM)
  if (str.trim().startsWith('+')) {
    str = `'${str}`; // force TEXT in Excel / Google Sheets
  }

  // replace line breaks
  str = str.replace(/\r?\n|\r/g, ' ');

  // escape quotes
  if (str.includes('"')) {
    str = str.replace(/"/g, '""');
  }

  // wrap if needed
  if (str.includes(',') || str.includes('"')) {
    str = `"${str}"`;
  }

  return str;
};

// ✅ Convert rows → CSV string
export const makeCSV = ({ headers = [], rows = [], excludedFields = [] }) => {
  const exportHeaders = headers.filter(
    (h) => !excludedFields.includes(h.field) && h.field !== 'actions' && h.type !== 'action',
  );

  const headerLine = exportHeaders.map((h) => escapeCSV(h.headerName || h.field)).join(',');

  const bodyLines = rows.map((row) =>
    exportHeaders
      .map((col) => {
        // valueGetter support
        if (typeof col.valueGetter === 'function') {
          const v = col.valueGetter({ row, value: row[col.field] });
          return escapeCSV(v);
        }
        return escapeCSV(row[col.field]);
      })
      .join(','),
  );

  return [headerLine, ...bodyLines].join('\n');
};

// ✅ Download CSV file
export const downloadCSV = (csvString, fileName = 'export.csv') => {
  // Excel on Windows ignores the Blob's charset and falls back to the system codepage
  // without a UTF-8 BOM, garbling anything non-ASCII (₹, accented names, etc). The BOM is
  // invisible and harmless to every other CSV reader, so this is safe to always add.
  const blob = new Blob(['﻿' + csvString], { type: 'text/csv;charset=utf-8;' });

  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};

/* ........................ Extract CSV ....................... */
export const extractCSV = async (headerArray = [], file, options = { skipFirstRow: false }) => {
  const extractedData = [];

  if (file.type !== 'text/csv') return;

  try {
    // Strip a leading UTF-8 BOM - present on anything exported by downloadCSV() above, or
    // saved by Excel itself - or it corrupts the first header cell (e.g. "﻿userID"
    // silently fails to match "userID").
    const File = (await file.text()).replace(/^﻿/, '');
    let rowData = File.split(/\r?\n/).filter((v) => v.trim() !== '');

    if (options?.skipFirstRow) rowData = rowData?.slice(1) || [];

    for (let row of rowData) {
      const splittedRow = row.split(',');
      const data = {};
      headerArray.forEach((headerName, index) => {
        data[headerName] = splittedRow[index] ? splittedRow[index].trim() : null;
      });

      extractedData.push(data);
    }

    return extractedData;
  } catch (error) {
    console.log({ error });
  }
};
